import { render, staticRenderFns } from "./lawyerRegisterH5.vue?vue&type=template&id=4cb5cc8c"
import script from "./lawyerRegisterH5.vue?vue&type=script&lang=js"
export * from "./lawyerRegisterH5.vue?vue&type=script&lang=js"
import style0 from "./lawyerRegisterH5.vue?vue&type=style&index=0&id=4cb5cc8c&prod&lang=less&scope=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports